module.exports = __webpack_public_path__ + "static/media/ifpb-logotipo.c906d2d4.png";